import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useSnackbar } from '~/modules/common/snackbar';
import { CHANGE_TASK_RESOURCE_USER_ALLOCATION_MODE } from '../enum';
import { useChangeTaskResource } from './useChangeTaskResource';

export const useOnSubmitHandler = ({
  existingResourceUserId,
  newResourceUser,
  onClose,
  onChangeTaskResourceSuccess,
  projectId,
  setIsSaving,
  taskId,
  allocationMode,
  availableHours,
  taskAllocationHours
}) => {
  const { changeTaskResource } = useChangeTaskResource();
  const { showSnackbar } = useSnackbar();
  const { formatMessage } = useIntl();

  const onSubmit = useCallback(async () => {
    setIsSaving(true);
    const hoursToAllocate =
      allocationMode ===
      CHANGE_TASK_RESOURCE_USER_ALLOCATION_MODE.ALLOCATE_WHAT_FITS
        ? availableHours
        : allocationMode ===
          CHANGE_TASK_RESOURCE_USER_ALLOCATION_MODE.ALLOCATE_FULL_AMOUNT
        ? taskAllocationHours
        : null;
    const {
      data: {
        changeTaskResourceUser: { taskResourceEstimateId }
      }
    } = await changeTaskResource({
      existingResourceUserId,
      newResourceUserId: newResourceUser?.id,
      projectId,
      taskId,
      allocationMode: !hoursToAllocate
        ? CHANGE_TASK_RESOURCE_USER_ALLOCATION_MODE.REMOVE_ALLOCATION
        : null,
      hoursToAllocate
    });

    onChangeTaskResourceSuccess &&
      (await onChangeTaskResourceSuccess({
        newTaskResourceEstimateId: taskResourceEstimateId
      }));

    showSnackbar &&
      showSnackbar(
        formatMessage(
          { id: 'changeTaskResourceDialog.snackbarSuccessMessage' },
          { ResourceName: newResourceUser?.displayText }
        )
      );

    onClose();
  }, [
    setIsSaving,
    changeTaskResource,
    existingResourceUserId,
    newResourceUser,
    projectId,
    taskId,
    allocationMode,
    availableHours,
    taskAllocationHours,
    onChangeTaskResourceSuccess,
    onClose,
    showSnackbar,
    formatMessage
  ]);

  return { onSubmit };
};

export default useOnSubmitHandler;
